export class Maestro_ConfiguracionComercializacion {
    id: number;
    codigo: string;
    descripcion: string;
    activo: boolean;
}